import { BreadcrumbPage } from "@/components/ui/breadcrumb";

import { BreadcrumbItem } from "@/components/ui/breadcrumb";

import { SidebarInset, SidebarTrigger } from "@/components/ui/sidebar";

import { AppSidebar } from "@/components/app-sidebar";
import { SidebarProvider } from "@/components/ui/sidebar";
import { BreadcrumbList } from "@/components/ui/breadcrumb";
import { Separator } from "@/components/ui/separator";
import { Breadcrumb } from "@/components/ui/breadcrumb";
import { Navigate, Outlet } from "react-router";
import { Toaster } from "@/components/ui/sonner";
import { useParams } from "react-router";
import { useTenant } from "@/api/tenant.api";
import { useTenantStore } from "@/store/tenant/tenant.store";
import { Routes } from "@/router/routes";
import { Loader } from "lucide-react";
import { useEffect } from "react";
import { useDocumentTitle } from "@/hooks/use-document-title";

export const TenantManagement = () => {
    const { id } = useParams();
    const { data: tenant, isFetched } = useTenant(Number(id));
    const title = useDocumentTitle();

    useEffect(() => {
        if (tenant) {
            useTenantStore.getState().selectTenant(tenant);
        }
    }, [tenant]);

    if (isFetched && !tenant) {
        return <Navigate to={`/${Routes.TenantSelection}`} replace />;
    }

    if (!tenant) {
        return <Loader className="w-4 h-4 animate-spin" />;
    }

    return (
        <SidebarProvider>
            <AppSidebar tenant={tenant} />
            <SidebarInset>
                <header className="flex h-16 shrink-0 items-center gap-2">
                    <div className="flex items-center gap-2 px-4">
                        <SidebarTrigger className="-ml-1" />
                        <Separator orientation="vertical" className="mr-2 h-4" />
                        <Breadcrumb>
                            <BreadcrumbList>
                                <BreadcrumbItem className="hidden md:block">
                                    <BreadcrumbPage>{title}</BreadcrumbPage>
                                </BreadcrumbItem>
                            </BreadcrumbList>
                        </Breadcrumb>
                    </div>
                </header>
                <div className="flex flex-1 flex-col gap-4 p-4 pt-0 flex-grow overflow-y-auto">
                    <Outlet />
                </div>
            </SidebarInset>
            <Toaster />
        </SidebarProvider>
    );
};
